import { checkPerm } from 'utils/permManager'

// Admin and campaign editor. Other roles do not see HRM.
const SIMULATION_TRAINING_ROLES = ['admin', 'edit_campaigns']

export const hasSimulationTrainingRole = (permissions) =>
  checkPerm(permissions || {}, SIMULATION_TRAINING_ROLES)

/** PHISHING_SIMULATION_ALLOWED. Plan rank is not the gate. */
export const isPhishingSimulationAllowed = (featureFlags) =>
  !!featureFlags?.PHISHING_SIMULATION_ALLOWED

export const canAccessSimulationTrainingSettings = (permissions, featureFlags) =>
  hasSimulationTrainingRole(permissions) && isPhishingSimulationAllowed(featureFlags)
